/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getFeatureFlags} from '../api'

 export const useQueryGetFeatureFlags = createReactQueryHook('getFeatureFlags', getFeatureFlags)
